import React from "react";
import { Mail, Linkedin, FileText, ArrowUp } from "lucide-react";
import { profileData } from "../mock";

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer style={{ background: "#0C0C0E", borderTop: "1px solid #1E1E24" }}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6 py-10">
        {/* Top row */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6">
          {/* Brand + back to top on mobile */}
          <div className="flex items-start justify-between sm:block">
            <div>
              <p className="text-white font-bold text-lg tracking-tight mb-0.5">
                Aditya Sonthalia<span className="text-[#06B6D4]">.</span>
              </p>
              <p className="text-xs text-[#52525B]">Growth PM · IIT Kanpur · Bengaluru</p>
            </div>
            {/* Back to top on mobile (inline) */}
            <button
              onClick={scrollTop}
              className="sm:hidden flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-medium text-[#71717A] border border-[#27272A] transition-all duration-200"
            >
              <ArrowUp className="w-3.5 h-3.5" /> Top
            </button>
          </div>

          {/* Links */}
          <div className="flex items-center gap-5 flex-wrap">
            <a href={`mailto:${profileData.email}`}
              className="flex items-center gap-1.5 text-sm text-[#71717A] hover:text-[#06B6D4] transition-colors duration-200">
              <Mail className="w-4 h-4" /> Email
            </a>
            <a href={profileData.linkedin} target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm text-[#71717A] hover:text-[#06B6D4] transition-colors duration-200">
              <Linkedin className="w-4 h-4" /> LinkedIn
            </a>
            <a href={profileData.resumeUrl} target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm text-[#71717A] hover:text-[#06B6D4] transition-colors duration-200">
              <FileText className="w-4 h-4" /> Resume
            </a>
            {/* Back to top on desktop */}
            <button onClick={scrollTop}
              className="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-medium text-[#71717A] hover:text-white hover:bg-white/5 border border-[#27272A] hover:border-[#3F3F46] transition-all duration-200">
              <ArrowUp className="w-3.5 h-3.5" /> Back to top
            </button>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-8 pt-5 border-t border-[#1E1E24] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-xs text-[#3F3F46]">© 2025 Aditya Sonthalia. All rights reserved.</p>
          <p className="text-xs text-[#3F3F46]">Built with precision · Powered by data</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

